import Events from '@/hooks/events';
import actions from '../constants';

export default {
  useSubscribeToRequestDataset: (category, { code }) => Events.useDispatchByCode(
    actions.SUBSCRIBE_TO_REQUEST_DATASET,
    category,
    code,
  ),
};
